module.exports = __webpack_public_path__ + "img/myinvestor-dark.7c4e892f.png";